import React from "react";

import cx from "classnames";
import { css } from "@emotion/react";


const styles = css({
  display: "block",
  margin: "5px 0 0",
  fontSize: "12px",
  lineHeight: 1.6,
  color: "#acb1c0"
});

interface FormHelpProps {
  children?: React.ReactNode;
  className?: string;
  [key: string]: any;
}

export default function FormHelp({
  children,
  className,
  ...restProps
}: FormHelpProps) {

  if (!children) {
    return null;
  }

  return (
    <p
      className={cx("form-help", className)}
      css={styles}
      {...restProps}>
      {children}
    </p>
  );
}
